import React from 'react';

interface NoteIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const NoteIcon: React.FC<NoteIconProps> = ({
  width = 12,
  height = 16,
  color = 'currentColor',
  className,
  style,
  title,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      role="img"
      aria-hidden={!title}
      aria-label={title}
    >
      {title && <title>{title}</title>}
      <path
        d="M9.73125 1H10C11.1031 1 12 1.89688 12 3V14C12 15.1031 11.1031 16 10 16H2C0.896875 16 0 15.1031 0 14V3C0 1.89688 0.896875 1 2 1H2.26875C2.6125 0.403125 3.25938 0 4 0H8C8.74063 0 9.3875 0.403125 9.73125 1ZM7.75 3.5C8.16562 3.5 8.5 3.16563 8.5 2.75C8.5 2.33437 8.16562 2 7.75 2H4.25C3.83437 2 3.5 2.33437 3.5 2.75C3.5 3.16563 3.83437 3.5 4.25 3.5H7.75ZM4.85 6.03438C4.59375 5.825 4.21562 5.86562 4.00625 6.12187L3.05938 7.29375L2.74688 6.90312C2.54063 6.64375 2.1625 6.60312 1.90313 6.80937C1.64375 7.01562 1.60313 7.39375 1.80938 7.65312L2.5875 8.625C2.7 8.76562 2.87187 8.85 3.05312 8.85C3.23438 8.85 3.40625 8.76875 3.52187 8.62813L4.9375 6.87813C5.14687 6.62188 5.10625 6.24375 4.85 6.03438ZM5.5 8C5.5 8.41562 5.83437 8.75 6.25 8.75H9.25C9.66562 8.75 10 8.41562 10 8C10 7.58437 9.66562 7.25 9.25 7.25H6.25C5.83437 7.25 5.5 7.58437 5.5 8ZM5.5 12C5.5 12.4156 5.83437 12.75 6.25 12.75H9.25C9.66562 12.75 10 12.4156 10 12C10 11.5844 9.66562 11.25 9.25 11.25H6.25C5.83437 11.25 5.5 11.5844 5.5 12ZM3 13C3.26522 13 3.51957 12.8946 3.70711 12.7071C3.89464 12.5196 4 12.2652 4 12C4 11.7348 3.89464 11.4804 3.70711 11.2929C3.51957 11.1054 3.26522 11 3 11C2.73478 11 2.48043 11.1054 2.29289 11.2929C2.10536 11.4804 2 11.7348 2 12C2 12.2652 2.10536 12.5196 2.29289 12.7071C2.48043 12.8946 2.73478 13 3 13Z"
        fill={color}
      />
    </svg>
  );
};

export default NoteIcon;
